<template>
	<date-picker
		v-if="onlyYears"
		:disabled="disabled"
		:input-attr="inputAttr"
		:value="date"
		:placeholder="placeholderGenerate"
		format="YYYY"
		value-type="YYYY"
		type="year"
		@input="$emit('on-input', $event)"
		:style="this.$route.name === 'journal' ? {} : { 'margin-bottom': '7px' }"
		class="component-date"
		>
		<template v-if="showIcon">
			<img
			class="icon-calendar-custom"
			slot="icon-calendar"
			:src="icon"
			/>
		</template>
	</date-picker>
	<date-picker
		v-else
		:disabled="disabled"
		:input-attr="inputAttr"
		:value="date"
		:placeholder="placeholderGenerate"
		format="DD/MM/YYYY"
		value-type="YYYY-MM-DD"
		@input="$emit('on-input', $event)"
		:style="this.$route.name === 'journal' ? {} : { 'margin-bottom': '7px' }"
		class="component-date"
	>
		<template v-if="showIcon">
			<img
				class="icon-calendar-custom"
				slot="icon-calendar"
				:src="icon"
			/>
		</template>
	</date-picker>
</template>

<script>
	import DatePicker from 'vue2-datepicker';
	import 'vue2-datepicker/index.css';
	import 'vue2-datepicker/locale/es';

	function inputAttr() {
		return {
			tabindex: this.tabindex,
		};
	}

	function placeholderGenerate() {
		return this.placeholder || 'aaaa-mm-dd';
	}

	export default {
		name: 'date-component',
		components: {
			DatePicker,
		},
		computed: {
			inputAttr,
			placeholderGenerate,
		},
		props: {
			date: [Date, String],
			disabled: {
				default: false,
				type: Boolean,
			},
			icon: String,
			placeholder: String,
			round: {
				default: false,
				type: Boolean,
			},
			showIcon: {
				default: true,
				type: Boolean,
			},
			tabindex: [String, Number],
			onlyYears: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.component-date {
		width: 100%;
	}

	.icon-calendar-custom {
		height: 15px;
	}

	.mx-datepicker {
		max-width: 100% !important;
	}

	.mx-input {
		height: 31px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/autocomplete/date-component.vue